module.exports = __webpack_public_path__ + "2ffa363801ab4991f79831e6aac0a341.webp";